<template>
  <div id="app-rerouted">
    <ContentfulBanner v-if="shouldShowBanner" :segment-event-name="'UpgradePricing_PostLogin_Banner'" />
    <router-view />
    <PoppinsCondensedFooter />
  </div>
</template>

<script>
import PoppinsCondensedFooter from '@/components/condensed_footer/PoppinsCondensedFooter.vue';
import ContentfulBanner from '@/components/contentful_banner/ContentfulBanner.vue';
import shouldShowContentfulBanner from '@/helpers/bannerDisplayLogic';

export default {
  name: 'App',
  components: {
    PoppinsCondensedFooter,
    ContentfulBanner,
  },
  computed: {
    shouldShowBanner() {
      return shouldShowContentfulBanner(this.$store.getters['account/getAccount'], this.$route.path);
    },
  },
};
</script>

<style lang="scss" scoped>
#app-rerouted {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);

  > :first-child {
    flex: 1;
  }
}
</style>
